import {
  APOLLO_CLIENTS,
  initializeApollo,
  initializeSecureApolloClient,
} from '@/graphql/client';
import type {
  OrderAppDeleteMetadataMutation,
  OrderAppDeleteMetadataMutationVariables,
  OrderAppError,
  OrderAppMetadataItem,
  OrderAppUpdateMetadataMutation,
  OrderAppUpdateMetadataMutationVariables,
} from '@/graphql/orderApp/api';
import {
  DeleteMetadataDocument,
  UpdateMetadataDocument,
} from '@/graphql/orderApp/api';

export const updateMetadata = async (
  opts: OrderAppUpdateMetadataMutationVariables,
  secureClient?: boolean,
): Promise<{ errors: OrderAppError[]; metadata: OrderAppMetadataItem[] }> => {
  const client = secureClient
    ? initializeSecureApolloClient()
    : initializeApollo();

  const { data } = await client.mutate<
    OrderAppUpdateMetadataMutation,
    OrderAppUpdateMetadataMutationVariables
  >({
    mutation: UpdateMetadataDocument,
    variables: opts,
    context: {
      client: APOLLO_CLIENTS.orderApp,
    },
  });

  return {
    metadata: data?.updateMetadata?.item?.metadata || [],
    errors: data?.updateMetadata?.errors || [],
  };
};

export const deleteMetadata = async (
  opts: OrderAppDeleteMetadataMutationVariables,
): Promise<{ errors: OrderAppError[]; metadata: OrderAppMetadataItem[] }> => {
  const client = initializeApollo();

  const { data } = await client.mutate<
    OrderAppDeleteMetadataMutation,
    OrderAppDeleteMetadataMutationVariables
  >({
    mutation: DeleteMetadataDocument,
    variables: opts,
    context: {
      client: APOLLO_CLIENTS.orderApp,
    },
  });

  return {
    metadata: data?.deleteMetadata?.item?.metadata || [],
    errors: data?.deleteMetadata?.errors || [],
  };
};
